module.exports = __webpack_public_path__ + "img/mes.a43c709e.png";